jQuery(document).ready(function () {
  function readURL(input) {
    if (input.files && input.files[0]) {
      // Reads the upload image
      var reader = new FileReader();
      reader.readAsDataURL(input.files[0]); // Updates the css of the preview with the image url

      reader.onload = function (e) {
        jQuery('#imagePreview').attr('src', e.target.result).hide().fadeIn(650);
      };
    }
  } // Changes the image with the chosen one by calling the function


  jQuery('#imageUpload').change(function () {
    readURL(this);
  });
});